import * as React from 'react';
import type {
  LogicProps,
  VerticalMenuProps,
  VerticalMenuImperativeActions,
} from '../VerticalMenu.types';
import extendItemsWithSelectionProp from './utils/extendItemsWithSelectionProp';
import filterVisibleItems from './utils/filterVisibleItems';
import VerticalMenuCommonSkin from './skinComps/VerticalMenuCommonSkin';
import styles from './styles/VerticalMenu.scss';

const VerticalMenuRoot: React.ForwardRefRenderFunction<
  VerticalMenuImperativeActions,
  VerticalMenuProps & LogicProps
> = (props, ref) => {
  const {
    a11y,
    ariaAttributes,
    translations,
    items = [],
    currentUrl,
    style: propStyle,
  } = props;
  const visibleItems = React.useMemo(() => filterVisibleItems(items), [items]);
  const itemsWithSelectionProp = React.useMemo(
    () => extendItemsWithSelectionProp(currentUrl, visibleItems),
    [currentUrl, visibleItems],
  );

  return (
    <VerticalMenuCommonSkin
      {...props}
      ref={ref}
      items={itemsWithSelectionProp}
      ariaLabel={ariaAttributes?.label ?? a11y?.label ?? translations.ariaLabel}
      style={{ ...styles, ...propStyle }}
    />
  );
};

export default React.forwardRef(VerticalMenuRoot);
